import { DomeComponent, DomeManipulator, DomeRouter, React } from "@lexriver/dome";
import { debounce } from "ts-debounce";
import { GlobalState } from "../GlobalState";
import { ServerProducts } from "../server-queries/ServerProducts";
import { UrlGenerator } from "../UrlGenerator";
import { EnumIconNames } from "../enums/EnumIconNames";
import css from './TopSearch.m.scss'
import { Settings } from "../../Settings";


interface Attrs{
    productType?:string
    productColor?:string
}

export class TopSearch extends DomeComponent<Attrs>{
    // protected showInputO = new ObservableValue<boolean>(false)

    // protected showTooltipO = new ObservableValue<boolean>(false)

    protected refSpanTooltip?:HTMLSpanElement
    protected refSpanTooltipText?:HTMLSpanElement

    protected refInput?:HTMLInputElement

    protected searchQuery = ''

    protected lastHideTooltipDatetime = new Date()

    render(){
        // console.log('rendering TopSearch', this.showInputO.get())
        return (
            <div class={css.searchContainer}>
                
                <input 
                    type="text" 
                    title="Поиск по товарам: по артикулу/названию/описанию" 
                    placeholder="Поиск по товарам" 
                    onInput={e => { this.onInputStart(e); this.onInputFinish(e); }} 
                    onKeypress={e => { this.onKeyPress(e) }} 
                    ref={ref => this.refInput = ref}
                />
                

                <div onClick={() => this.onButtonClick()} class={css.buttonFind}>
                    <span class={EnumIconNames.Search} />
                </div>

                {/* <ButtonIcon iconName={EnumIconNames.Search} onClick={() => onClick()} /> */}

                {/* {this.showTooltipO.get() && */}
                <span class={css.tooltip} ref={ref => this.refSpanTooltip = ref}>
                    <span ref={ref => this.refSpanTooltipText = ref}></span>
                    <span class={css.tooltipArrow}></span>
                </span>
                {/* } */}
                

                {/* <div onClick={() => this.showInputO.set(!this.showInputO.get())} class={css.buttonContainer}>
                    <Icon iconName={EnumIconNames.Search} />
                </div> */}
            </div>

        )
    }

    protected afterRender(): void {
        GlobalState.topBarSearchIsVisibleO.eventOnChange.subscribe((isVisible) => {
            if(isVisible){
                this.showInput()
            } else {
                this.hideInput()
            }
        })
        if(!this.searchQuery){
            // this.hideInput()
            GlobalState.topBarSearchIsVisibleO.set(false)
            this.hideTooltip()
        }

        GlobalState.eventPageChange.subscribe(() => {
            // console.log('### hide input on page change event')
            // this.hideInput()
            GlobalState.topBarSearchIsVisibleO.set(false)
            this.hideTooltip()
        })
    }


    // afterRender(){
    //     this.showInputO.eventOnChange.subscribe(() => {
    //         //console.log('show zero change, so reload page!')
    //         if(!DomeManipulator.isInDom(this.rootElement)) return {unsubscribe:true}
    //         this.scheduleUpdate()
    //     })
    //     // this.scheduleUpdate()
    // }
    


    protected onInputFinish = 
        debounce(async (e) => {
            //console.log('onInput', e.target.value)
            this.searchQuery = (e.target.value ?? '').trim()
            if(this.searchQuery.length == 0) return
            // console.log('diff=', new Date().valueOf() - this.lastHideTooltipDatetime.valueOf(), this.lastHideTooltipDatetime)
            if(new Date().valueOf() - this.lastHideTooltipDatetime.valueOf() < 1000) return // do not show tooltip too ofter
            const count = await ServerProducts.getSearchCountAsync2({
                searchQuery: this.searchQuery,
                productType: this.attrs.productType,
                showZeroQuantityProducts: GlobalState.productShowZeroQuantityProductsO.get(),
                productColor: this.attrs.productColor ?? Settings.productColorAll,
                showHiddenProducts: GlobalState.productShowHiddenProductsO.get() ?? false
                })
            // console.log('search count=', count)
            await this.showTooltipAsync(this.searchQuery, count)
        }
        , 1000)

    protected async showTooltipAsync(query:string, count:number){
        console.log('showTooltipAsync', 'query=', query, 'this.searchQuery=', this.searchQuery)
        if(!this.searchQuery) return
        if(query !== this.searchQuery) return
        if(!this.refSpanTooltipText) return
        if(!this.refSpanTooltip) return
        await DomeManipulator.removeAllChildrenAsync(this.refSpanTooltipText)
        
        let text = <span></span>
        if(count == 0 ) text = <span>По запросу <strong>{query}</strong> не будет найдено ни одного товара</span>
        else {
            const sentenceType = new Intl.PluralRules('ru').select(count)
            if(sentenceType === 'one'){
                text = <span>По запросу <strong>{query}</strong> будет найден <strong>{count}</strong> товар</span>
            } else if(sentenceType === 'few'){
                text = <span>По запросу <strong>{query}</strong> будет найдено <strong>{count}</strong> товара</span>
            } else if(sentenceType === 'many'){
                text = <span>По запросу <strong>{query}</strong> будет найдено <strong>{count}</strong> товаров</span>
            } else {
                console.error('no text for sentenceType', sentenceType)
                text = <span>По запросу <strong>{query}</strong> будет найдено <strong>{count}</strong> товаров</span>
            }
        }
        this.refSpanTooltipText.appendChild(<span>{text}</span>)
        this.refSpanTooltip.style.display = 'inline-block'
        this.refSpanTooltip.classList.add(css.zoomInTooltip)

        setTimeout(() => {
            this.hideTooltip()
        }, 5000)
    }

    protected checkIfInputIsVisible(){
        if(!this.refInput) return false
        if(this.refInput.style.display == 'none'){
            return false
        }
        return true
    }



    protected showInput(){
        if(!this.refInput) return
        this.refInput.style.display = 'block'
        this.refInput.classList.add(css.showInputAnimation)
        setTimeout(() => {
            this.refInput?.focus()
        }, 10)
        setTimeout(() => {
            this.refInput?.classList.remove(css.showInputAnimation)
        }, 200)
    }

    protected hideInput(){
        if(!this.refInput) return
        // this.refInput.classList.remove(css.showInputAnimation)
        this.refInput.classList.add(css.hideInputAnimation)
        setTimeout(() => {
            if(!this.refInput) return
            this.refInput.style.display = 'none'
            this.refInput.classList.remove(css.hideInputAnimation)
        }, 180)
        
    }

    protected clearInput(){
        if(!this.refInput) return
        this.refInput.value = ''
        this.searchQuery = ''
    }

    protected hideTooltip(){
        if(this.refSpanTooltip && this.refSpanTooltip.style.display == 'none') return
        // console.log('hide tooltip')
        // if(!this.spanTooltip) return
        // this.spanTooltip.style.display = 'none'
        if(!this.refSpanTooltip) return
        this.refSpanTooltip.classList.remove(css.zoomInTooltip)
        this.refSpanTooltip.classList.add(css.zoomOutTooltip)
        setTimeout(() => {
            if(!this.refSpanTooltip) return
            this.refSpanTooltip.style.display = 'none'
            this.refSpanTooltip.classList.remove(css.zoomOutTooltip)
            this.lastHideTooltipDatetime = new Date()
        }, 200)

    }

    protected onInputStart = (e) => {
        this.hideTooltip()
    }



    protected onKeyPress(e){
        if(e.key !== 'Enter') return
        this.onButtonClick()
    }
    
    protected onButtonClick(){
        if(this.checkIfInputIsVisible()){
            // this.showInputO.set(true)
            this.searchQuery = (this.refInput?.value ?? '').trim()
            this.hideTooltip()
            // this.clearInput()

            if(this.searchQuery){
                // console.log('navigating to product search', this.searchQuery)
                DomeRouter.navigate(UrlGenerator.productSearch({ query:this.searchQuery, productType: this.attrs.productType }))
                this.hideInput() // just in case? can be removed?
                this.hideTooltip() // just in case? can be removed?

            } else {
                GlobalState.topBarSearchIsVisibleO.set(false)
                // this.hideInput()
            }
        } else {
            GlobalState.topBarSearchIsVisibleO.set(true)
            this.showInput()
            
        }
    }


}